import {FC} from 'react'
import {gql} from '@apollo/client'
import {MultiTagFilteringFieldRow} from 'components/SearchForm/MultiTagFilteringFieldRow'
import {useQuery} from 'hooks/graphql'
import {withNull} from 'libs/options'

const COUNTRIES = gql`
  query countries {
    client {
      employeeConnections {
        countries {
          id
          name
        }
      }
    }
  }
`

interface CountriesQueryResult {
  client: {
    employeeConnections: {
      countries: {
        id: string
        name: string
      }[]
    }
  }
}

export const Countries: FC = () => {
  const {data} = useQuery<CountriesQueryResult>(COUNTRIES, {fetchPolicy: 'cache-and-network'})
  const countries = data?.client?.employeeConnections?.countries || []

  return <MultiTagFilteringFieldRow header="居住国" name="countries" list={withNull(countries)} shouldUnregister />
}
